import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const AddExceptionActionTypes = {
  ADD_EXCEPTION: type('[Add Exception sub] Add Exception'),
  ADD_RULE_EXCEPTION_EXCEPTION: type('[Add Exception sub] Add Rule Exception'),
  UPDATE_RULE_EXCEPTION_EXCEPTION: type('[Add Exception sub] Update Rule Exception'),
  REMOVE_RULE_EXCEPTION_EXCEPTION: type('[Add Exception sub] Remove Rule Exception'),
  ADD_EXCEPTION_SUCCESS: type('[Add Exception sub] Add Exception Success'),
  ADD_EXCEPTION_SELF: type('[Add Exception sub] Add Exception Self'),
  ADD_EXCEPTION_FAIL: type('[Add Exception sub] Add Exception Server Error')
};

export class AddExceptionAction implements Action {
  readonly type = AddExceptionActionTypes.ADD_EXCEPTION;

  constructor(public payload?: any) {}
}
export class AddRuleExceptionAction implements Action {
  readonly type = AddExceptionActionTypes.ADD_RULE_EXCEPTION_EXCEPTION;

  constructor(public payload?: any) {
    console.log(payload)
  }
}
export class UpdateRuleExceptionAction implements Action {
  readonly type = AddExceptionActionTypes.UPDATE_RULE_EXCEPTION_EXCEPTION;

  constructor(public payload?: any) {
    console.log(payload)
  }
}
export class RemoveRuleExceptionAction implements Action {
  readonly type = AddExceptionActionTypes.REMOVE_RULE_EXCEPTION_EXCEPTION;

  constructor(public payload?: any) {
    console.log(payload)
  }
}
export class AddExceptionSuccessAction implements Action {
  readonly type = AddExceptionActionTypes.ADD_EXCEPTION_SUCCESS;

  constructor() {}
}

export class AddExceptionSelfAction implements Action {
  readonly type = AddExceptionActionTypes.ADD_EXCEPTION_SELF;

  constructor() {}
}

export class AddExceptionFailAction implements Action {
  readonly type = AddExceptionActionTypes.ADD_EXCEPTION_FAIL;

  constructor(public payload?: number) {}
}
